import { Progress } from '~/components/UI/shadcn/progress'

type ProgressProps = {
  value: number
  max: number
  barColour: 'light-blue' | 'chartreuse' | 'white' | undefined | null
  showPercentage?: boolean
  className?: string
}

const FormUIProgress = ({
  value,
  max,
  barColour,
  showPercentage = true,
  className
}: ProgressProps) => {
  return (
    <div className={showPercentage ? 'space-y-3xs' : ''}>
      {showPercentage && (
        <div className='text-right'>
          <span className='font-mono text-base'>{value}%</span>
        </div>
      )}
      <Progress
        value={value}
        max={max}
        className={className}
        barColour={barColour}
      />
    </div>
  )
}

export default FormUIProgress
